export default __webpack_public_path__ + "static/media/ClairaS.68fae171.png";